export function purchaseCostQuality(rows, basis) {
    const suffix = basis === "completed" ? "Net" : "Gross";
    const qualityAvailable = rows.every((row) => row.purchaseCostQualityAvailable !== false);
    const unknownCount = rows.reduce((sum, row) => sum + Number(row[`purchaseCostUnknown${suffix}`] ?? 0), 0);
    const estimatedCount = rows.reduce((sum, row) => sum + Number(row[`purchaseCostEstimated${suffix}`] ?? 0), 0);
    const explicitlyIncomplete = rows.some((row) => row[`purchaseCostComplete${suffix}`] === false);
    const hasQualityContract = rows.some((row) => typeof row.purchaseCostQualityAvailable === "boolean"
        || typeof row[`purchaseCostComplete${suffix}`] === "boolean"
        || typeof row[`purchaseCostUnknown${suffix}`] === "number"
        || typeof row[`purchaseCostEstimated${suffix}`] === "number");

    return {
        available: qualityAvailable,
        complete: unknownCount === 0 && (!hasQualityContract || (qualityAvailable && !explicitlyIncomplete)),
        unknownCount,
        estimatedCount,
    };
}

export function financialMetricAvailable(value, quality) {
    return quality?.complete === true && value !== null && value !== undefined;
}

export function hasReturnedMoneyMetric(rows, field) {
    return Array.isArray(rows) && rows.some((row) => row?.[field] !== undefined);
}

export function sumCompleteMoneyAmounts(rows, field) {
    if (!Array.isArray(rows) || rows.length === 0) {
        return null;
    }

    let total = 0;

    for (const row of rows) {
        const amount = row?.[field]?.amount;

        if (amount === null || amount === undefined || amount === "") {
            return null;
        }

        const numericAmount = Number(amount);

        if (!Number.isFinite(numericAmount)) {
            return null;
        }

        total += numericAmount;
    }

    return total;
}

export function productProfitabilitySummaryAvailable(summary) {
    return summary?.purchaseCostComplete !== false
        && Number(summary?.purchaseCostUnknownCount ?? 0) === 0
        && summary?.profitAfterMarketing != null
        && summary?.grossMargin != null
        && summary?.allocatedMarketingSpend != null;
}

export function productProfitabilityRowAvailable(product) {
    return product?.purchaseCostComplete === true
        && product?.grossMargin != null
        && product?.profitAfterMarketing != null;
}

export function productProfitabilityColumnsAvailable(summary, totalItems) {
    return Number(totalItems ?? 0) > 0 && summary?.purchasePrice != null;
}

export function completeProfitabilityRows(rows, limit = 10) {
    return rows.filter((row) => row.purchaseCostComplete === true).slice(0, limit);
}
